<template>
  <Button class="button-enter">
    <slot></slot>
  </Button>
</template>
<script>
import { defineComponent } from "vue";

import Button from "./Button.vue";
export default defineComponent({
  name: "EnterButton",
  components: {
    Button,
  },
});
</script>
<style scoped>
.button-enter {
  background: #93ca76; /* 「淡萌黄」 */
}
</style>
